module.exports = __webpack_public_path__ + "static/media/undead_background.09167d21.png";